import axios from "axios";
import { config } from './Config'


axios.defaults.baseURL=config.url.API_URL;


export default axios.create({
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
        "Content-type": "application/json"
    },
    
});
